import type { Group } from '@gik/core/models/gik/Group';
import type { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import { ModalButtonFooter } from '@gik/ui-legacy/Modal';
import { UI } from '@gik/ui-legacy/UIManager';
import { AddInkindPagesModalContent } from '../components/AddInkindPagesModal.tsx';

/**
 * Opens the "Add InKind Pages to this Group" modal.
 *
 * Lets an organizer browse the Pages they own or organize and add them to
 * the supplied group. Resolves to the Pages that were successfully added
 * (empty when the user added nothing or cancelled), so callers can insert
 * them optimistically while Algolia's index catches up.
 */
export function openAddInkindPagesModal(group: Group): Promise<InkindPageAPIModel[] | undefined> {
  return UI.dialog<InkindPageAPIModel[]>(
    ({ footerRef, close }) => <AddInkindPagesModalContent group={group} buttonsPortal={footerRef} onClose={close} />,
    {
      title: 'Add InKind Pages to this Group',
      closable: true,
      className: 'gik-add-inkind-pages-modal',
      footer: <ModalButtonFooter centeredButtons={false} smallButtonsOnDesktop={false} />,
    }
  );
}
